// Sends quiz milestones to Google Tag Manager (window.dataLayer) so Google
// Ads, Meta and GA4 can count quiz leads. Tags and conversions are set up in
// Tag Manager, not here.
//
// Never send personal details (name, email, phone, postal code) - only what
// happened, the province, the system type and the quote value.
//
// Events:
//   quiz_submitted        visitor finished the Typeform questions
//   quiz_quote_shown      three options shown (quiz_province, quiz_system_type)
//   quiz_no_quote         lead saved without a price (quiz_reason)
//   quiz_option_selected  visitor picked an option (quiz_option_rank, value)
//   quiz_lead_submitted   visitor clicked "Finalize with a Representative" or
//                         "Get Financing" (quiz_lead_type, value)
export const trackQuizEvent = (event, params = {}) => {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (err) {
    // Tracking must never break the quiz.
  }
};
